import { createContext, useState } from "react";

export const ClaimContext = createContext<any>({});

type ClaimProps = {
  children: React.ReactNode; //👈 children prop type
};

export const ClaimProvider = ({ children }: ClaimProps) => {
  const [claimData, setClaimData] = useState({
    Documents: [],
  });

  const resetClaimData = () => {
    // Set claimData to initial state or empty object, depending on your needs
    setClaimData({ Documents: [] });
  };

  return (
    <ClaimContext.Provider
      value={{
        claimData,
        setClaimData,
        resetClaimData,
      }}
    >
      {children}
    </ClaimContext.Provider>
  );
};
